import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout=()=>{
    return(
        <>
{/* <div style={{ background: "#edf1f5", minHeight: "100vh" }}> */}
            <Header />
            <Sidebar />
             {/* </div> */}
            {/* PAGE CONTENT */}
      <main
        style={{
          marginLeft: "230px", // sidebar width
          marginTop: "52px",   // header height
          padding: "20px",
          minHeight: "100vh",
          background: "#edf1f5",
        }}
      >
        <Outlet />
      </main>
    </>
  );
};

export default Layout;